<template>
  <div class="drink-container py-5">
      <div v-for="(section, sectionIndex) in menusections" :key="sectionIndex" class="menu-section">
        <div class="foodmenu-headline">
          <h2>{{ section.heading }}</h2>
        </div>
            <div class="matmeny-container">
        <div v-for="(item, itemIndex) in section.items" :key="itemIndex" class="foodmenu-item">
          <div class="foodmenu-item-info">
            <h4>{{ item.name }}</h4>
            <p>{{ item.desc }}</p>
          </div>
          <div class="foodmenu-item-price pe-2">
            <h4>{{ item.price }}</h4>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    export default {
        data() {
            return {
                menusections: [
                    {
                    heading: 'Läsk/alkoholfritt',
                    items: [
                    {name: 'pepsi (30cl)', price: '42:-'},
                    {name: 'pepsi max (30cl)', price: '42:-'},
                    {name: 'zingo (30cl)', price: '42:-'},
                    {name: '7up (30cl)', price: '42:-'},
                    {name: 'mineralvatten', price: '42:-'},
                    {name: 'bryggkaffe', price: '42:-'},
                    {name: 'alkoholfri öl (33cl)', price: '59:-'},
                    {name: 'alkoholfri päroncider', price: '59:-'},
                    {name: 'alkoholfritt vin', price: '79:-'},
                    {name: 'alkoholfri drink', price: '89:-'},

                    ]
                    },
                    {
                    heading: 'Fatöl',
                    items: [
                    {name: 'Norrlands guld', desc: '', price: '62:-'},
                    {name: 'Norrlands guld (AW)', desc: '', price: '42:-'},
                    {name: 'Estrella Damm', desc: '', price: '75:-'},
                    {name: 'A ship full of ipa', price: '98:-'},
                    {name: 'Krusovice imperial', desc: '', price: '98:-'},
                    ]
                    },
                    {
                    heading: 'Flasköl', 
                    items: [
                    {name: 'Mariestad (33cl)', desc: 'mellanöl', price: '72:-'},
                    {name: 'Sol (33cl)', desc: '', price: '72:-'},
                    {name: 'Heineken', desc: '', price: '72:-'},
                    {name: 'Sleepy bulldog', desc: '', price: '72:-'},
                    {name: 'Daura damm', desc: 'Glutenfri', price: '72:-'},
                    {name: 'Mariestad', desc: 'Export', price: '92:-'},
                    {name: 'veteöl', desc: '', price: '102:-'}            
                    ]
                    },
                    {
                    heading: 'Cider/breezer',
                    items: [
                    {name: 'Briska', desc: 'Päron/fläder/hallon', price: '79:-'},
                    {name: 'Strongbow', desc: '', price: '79:-'},
                    {name: 'Smirnoff ice', desc: '', price: '79:-'},
                    {name: 'Breezer', desc: 'Mango', price: '79:-'}
                    ]
                    }, 
                    {
                    heading: 'Rött/vitt/rosé vin',
                    items: [
                    {name: 'Husets glas', desc: '', price: '88:-'},
                    {name: 'Husets flaska', desc: '', price: '389:-'},
                    {name: 'Husets flaska (AW)', desc: '', price: '329:-'}
                    ]
                    },
                    {
                    heading: 'Mouserrande',
                    items: [
                    {name: 'ett glas cava', desc: '', price: '103:-'},
                    {name: 'en flaska cava', desc: '', price: '449:-'},
                    ]
                    },
                     {
                    heading: 'drinkar/cocktails (5cl)',
                    items: [
                    {name: 'Gin & Tonic', desc: '', price: '139:-'},
                    {name: 'Cuba Libre', desc: 'Rom, cola, lime', price: '139:-'},
                    {name: 'Vodka Energy', desc: 'Vodka, energidryck', price: '139:-'},
                    {name: 'Jägermeister Energy', desc: 'Jägermeister, energidryck', price: '139:-'},

                    {name: 'White Russian', desc: 'Vodka, kahlua, mjölk', price: '152:-'},
                    {name: 'Solero', desc: 'Likör 43, passion juice, mjölk', price: '152:-'},
                    {name: 'Rosa pantern', desc: 'Likör 43, vodka, mjölk, grenadine, grädde, strössel', price: '152:-'},
                    {name: 'Pina colada', desc: 'Ljus rom, malibu, ananas juice, mjölk', price: '152:-'},
                    {name: 'Margarita', desc: 'Tequila, cointreau, lime juice, sockerlag', price: '152:-'},
                    {name: 'Cosmopolitan', desc: 'Citronvodka, cointreau, tranbärsjuice', price: '152:-'},
                    {name: 'Whiskey sour', desc: 'Whiskey, angostura bitter, sockerlag, äggvita, citronjuice', price: '152:-'},
                    {name: 'Amaretto sour', desc: 'Disaronno, angostura bitter, sockerlag, äggvita, citronjuice', price: '152:-'},
                    {name: 'Espresso martini', desc: 'Kahlua, vodka, bryggkaffe, sockerlag', price: '152:-'},

                    {name: 'Skinny beach', desc: 'Vodka, soda, lime', price: '152:-'},
                    {name: 'Twister', desc: 'Bacardi limon, limejuice, strawberry puree, sprite', price: '152:-'},
                    {name: 'P2', desc: 'Vaniljvodka, Sourz Sour Apple, sprite', price: '152:-'},
                    {name: 'Aperol Spritz', desc: 'Prosecco, aperol, soda, apelsin', price: '152:-'},
                    {name: 'Limoncello Spritz', desc: 'Prosecco, limoncello, soda, citron', price: '152:-'},
                    {name: 'Blue lagoon', desc: 'Vodka, bolsblue, sprite', price: '152:-'},
                    {name: 'Sex on the beach', desc: 'Peachtree, vodka, tranbärsjuice, apelsinjuice', price: '152:-'},

                    {name: 'Irish coffee', desc: 'Jameson, bryggkaffe, grädde, farinsocker', price: '152:-'},
                    {name: 'Baileys coffee', desc: 'Baileys, bryggkaffe, grädde', price: '152:-'},
                    {name: 'Kaffe Karlsson', desc: 'Baileys, cointreau, bryggkaffe, grädde', price: '152:-'},

                    {name: 'Jack & Coke', desc: 'Jack Daniels, cola', price: '179:-'},


                    ]
                    },
                    {
                    heading: 'shots (5cl)',
                    items: [
                    {name: 'Tequila', price: '112:-'},
                    {name: 'Minttu', desc: 'Choklad eller pepparmint', price: '112:-'},
                    {name: 'Sambuca', price: '112:-'},
                    {name: 'Fisherman', price: '112:-'},
                    {name: 'Lakrits', price: '112:-'},

                    {name: 'Fernet branca', price: '112:-'},
                    {name: 'Fernet menta', price: '112:-'},
                    {name: 'Gammeldansk', price: '112:-'},
                    {name: 'Fireball', price: '112:-'},

                    {name: 'Sour fisk cola', price: '112:-'},
                    {name: 'Sour fisk hallon/lakrits', price: '112:-'},
                    {name: 'Sour fisk päron', price: '112:-'},
                    {name: 'Hotshots', price: '122:-'},
                    
                  ]
                    },
                    {
                    heading: 'Whiskey/cognac',
                    items: [
                    {name: 'Jameson', price: '29:-/cl'},
                    {name: 'Famous Grouse', price: '29:-/cl'},
                    {name: 'Jack Daniels', price: '29:-/cl'},
                    {name: 'Jim Beam Bourbon', price: '29:-/cl'},
                    {name: 'Black Label', price: '33:-/cl'},
                    {name: 'Plantation grande reserve', price: '29:-/cl'},
                    {name: 'Plantation XO', price: '59:-/cl'},
                    {name: 'Bowmore 12y', price: '35:-/cl'},
                    {name: 'Laphroaig 10y', price: '39:-/cl'},
                    {name: 'Makers mark', price: '39:-/cl'},
                    {name: 'Macallan 12y', price: '39:-/cl'},
                    {name: 'Lagavulin 16y', price: '49:-/cl'},
                    {name: 'Blue label', price: '99:-/cl'},
                    {name: 'Cognac braastad', price: '32:-/cl'},
                    {name: 'Xante cognac', price: '32:-/cl'},

                    ]
                    },
                ]
            }
        }
    }
</script>